import React, { Component } from "react";

export default class Footer extends Component {

	render() {
		return (
			<footer>
				<div className="footer-top-part">
					<b>"Safety training 4 a safer future"</b>
					<div className="footer-images">
						<img className="footer-image-1" src="/assets/images/Highfield logo.png"/>
						<img className="footer-image-2" src="/assets/images/Fire%20Fighters%20Charity%20Logo.jpg"/>
					</div>
				</div>
				<div className="footer-bottom-part">
					<p className="footer-copyright">&copy; Copyright SafeT4Sure 2010-2017</p>
				</div>
			</footer>
		);
	}
}



// WEBPACK FOOTER //
// ./js/components/Global/Footer.jsx